import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { String, Subtitle, Button, Theme } from "@silvertours/front-shared";
import Image from "next/image";
import { useMedia } from "react-use";
import { Anchor, Footer, InfoWrapper, InteractivePhoneNumber, OpeningTimesWrapper, VoucherText, VoucherWrapper } from "./OpeningTimes.styles";
import { useSiteInfo } from "../../SiteInfo";
import email from "./email.png";
import call from "./call.png";
import { Schedule } from "./Schedule";
var defaultProps = {
    showHeader: true,
    showNumber: true,
    showVoucherInfo: false
};
var OpeningTimes = function(param) {
    var showVoucherInfo = param.showVoucherInfo, showHeader = param.showHeader, showNumber = param.showNumber, _translations = param.translations, buttonHref = _translations.buttonHref, buttonLabel = _translations.buttonLabel, voucher = _translations.voucher, title = _translations.title;
    var ref = useSiteInfo(), _settings = ref.settings, phoneNumber = _settings.phoneNumber, language = _settings.language;
    var formattedNumber = String.parsePhoneNumber(phoneNumber, language);
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), false);
    return /*#__PURE__*/ _jsxs(OpeningTimesWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(InfoWrapper, {
                children: [
                    showHeader && /*#__PURE__*/ _jsx(Subtitle, {
                        as: "p",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Image, {
                        src: email,
                        objectFit: "contain",
                        alt: "Email",
                        height: 150
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        href: buttonHref,
                        variant: "primary",
                        fullWidth: true,
                        target: "_blank",
                        children: buttonLabel
                    }),
                    showNumber && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: call,
                                objectFit: "contain",
                                alt: "Email",
                                height: 150
                            }),
                            !isMobile && /*#__PURE__*/ _jsx(InteractivePhoneNumber, {
                                textColor: "green",
                                children: /*#__PURE__*/ _jsx(Anchor, {
                                    href: formattedNumber.url,
                                    children: formattedNumber.international
                                })
                            }),
                            isMobile && /*#__PURE__*/ _jsx(Button, {
                                href: formattedNumber.url,
                                variant: "secondary",
                                fullWidth: true,
                                children: formattedNumber.international
                            }),
                            /*#__PURE__*/ _jsx(Schedule, {
                                showVoucherInfo: showVoucherInfo
                            })
                        ]
                    })
                ]
            }),
            showVoucherInfo && voucher && /*#__PURE__*/ _jsx(Footer, {
                children: /*#__PURE__*/ _jsxs(VoucherWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            href: "/voucher.html",
                            rel: "nofollow",
                            variant: "secondary",
                            fullWidth: true,
                            children: voucher.buttonLabel
                        }),
                        /*#__PURE__*/ _jsx(VoucherText, {
                            textColor: "grey",
                            children: voucher.text
                        })
                    ]
                })
            })
        ]
    });
};
OpeningTimes.defaultProps = defaultProps;
export { OpeningTimes };
